import { NextPage } from 'next'
import { CircleHead } from '@/components/common/Head'
import React, { useEffect, useState } from 'react'
import { EnterpriseTemplate } from '@/components/pages/enterprise/templates/EnterpriseTemplate'
import { css } from '@emotion/react'
import { colors, font, mq } from 'plume-ui'
import { IcomoonIcon } from '@/components/atoms/IcomoonIcon'
import Slider from 'react-slick'
import Image from 'next/image'
import circle from '@/static/images/enterprise/circle/logo.png'

const colorOrange: string = '#FC6947'
const colorYellow: string = '#ffe381'
interface User {
  name: string
  imgSrc: string
}
const CirclePage: NextPage = () => {
  const sliderSettings = {
    arrows: true,
    dots: false,
    infinite: false,
    speed: 650,
    slidesToShow: 3,
    slidesToScroll: 1,
    swipeToSlide: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 770,
        settings: {
          arrows: false,
          variableWidth: true,
          slidesToShow: 1,
        },
      },
    ],
  }

  const [show, setShow] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      setShow(true)
    }, 100)
  }, [])

  return (
    <>
      <CircleHead />
      <EnterpriseTemplate>
        <div
          css={css`
            background-color: ${colors.white10};
          `}
        >
          <header
            className={show ? 'show' : ''}
            css={css`
              position: relative;
              background: url('/static/images/enterprise/circle/hero.jpg') 50%
                50% no-repeat;
              background-size: cover;
              mask-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQ0MCIgaGVpZ2h0PSI5MjciIHZpZXdCb3g9IjAgMCAxNDQwIDkyNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wIDc0OS4zNDlWMEgxNDQwVjc0OS4zNDlDMTIyNi4yOCA4NjIuNjAxIDk4MC45MiA5MjcgNzIwIDkyN0M0NTkuMDggOTI3IDIxMy43MTkgODYyLjYwMSAwIDc0OS4zNDlaIiBmaWxsPSIjRDlEOUQ5Ii8+Cjwvc3ZnPgo=');
              mask-size: cover;
              mask-position: bottom;
            `}
          >
            <h1
              css={css`
                margin: 0;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                grid-row-gap: 8px;
                height: min(88vh, 414px);
                background: url('/static/images/enterprise/circle/title-bg.png')
                  50% 50% no-repeat;
                background-size: 404px auto;
                opacity: 0;
                transition: opacity 0.6s ease-in;
                .show & {
                  opacity: 1;
                }
                ${mq.large} {
                  grid-row-gap: 12px;
                  height: min(88vh, 808px);
                  background-size: 887px auto;
                }
              `}
            >
              <div
                css={css`
                  width: 96px;
                  height: auto;
                  margin-block-start: 16px;
                  margin-inline: auto;
                  ${mq.large} {
                    width: 210px;
                  }
                `}
              >
                <Image src={circle} alt="INITIAL Circle" />
              </div>
              <span
                css={css`
                  font-size: 10px;
                  font-weight: ${font.weight.bold};
                  line-height: 1.5;
                  letter-spacing: 0.14em;
                  ${mq.large} {
                    font-size: 16px;
                  }
                `}
              >
                ユーザーコミュニティ
              </span>
            </h1>
            <ul
              css={css`
                margin: 0;
                padding: 0;
              `}
            >
              <Circle
                css={css`
                  right: calc(50% + 111px);
                  bottom: calc(min(88vh, 414px) / 2 + 64px);
                  width: 54px;
                  height: 54px;
                  background-color: #fa6988;
                  transform: scale(0) rotate(180deg);
                  opacity: 0;
                  transition:
                    opacity 0.4s ease-in 0.8s,
                    transform 0.4s ease-in 0.8s;
                  .show & {
                    transform: scale(1) rotate(360deg);
                    opacity: 1;
                  }
                  ${mq.large} {
                    right: calc(50% + 247px);
                    bottom: calc(min(88vh, 808px) / 2 + 132px);
                    width: 118px;
                    height: 118px;
                  }
                `}
              >
                <span
                  css={css`
                    font-size: 10px;
                    line-height: 1.5;
                    letter-spacing: 0.02em;
                    ${mq.large} {
                      font-size: 15px;
                    }
                  `}
                >
                  勉強会
                </span>
              </Circle>
              <Circle
                css={css`
                  left: calc(50% + 71px);
                  bottom: calc(min(88vh, 414px) / 2 + 61px);
                  width: 82px;
                  height: 82px;
                  background-color: #fc6947;
                  transform: scale(0) rotate(180deg);
                  opacity: 0;
                  transition:
                    opacity 0.4s ease-in 1.1s,
                    transform 0.4s ease-in 1.1s;
                  .show & {
                    transform: scale(1) rotate(360deg);
                    opacity: 1;
                  }
                  ${mq.large} {
                    left: calc(50% + 153px);
                    bottom: calc(min(88vh, 808px) / 2 + 128px);
                    width: 180px;
                    height: 180px;
                  }
                `}
              >
                <span
                  css={css`
                    font-size: 12px;
                    line-height: 1.5;
                    letter-spacing: 0.02em;
                    ${mq.large} {
                      font-size: 18px;
                    }
                  `}
                >
                  ユーザー
                  <br />
                  交流会
                </span>
              </Circle>
              <Circle
                css={css`
                  left: calc(50% + 89px);
                  top: calc(min(88vh, 414px) / 2 + 62px);
                  width: 66px;
                  height: 66px;
                  background-color: #08c5dc;
                  transform: scale(0) rotate(180deg);
                  opacity: 0;
                  transition:
                    opacity 0.4s ease-in 1.4s,
                    transform 0.4s ease-in 1.4s;
                  .show & {
                    transform: scale(1) rotate(360deg);
                    opacity: 1;
                  }
                  ${mq.large} {
                    left: calc(50% + 194px);
                    top: calc(min(88vh, 808px) / 2 + 145px);
                    width: 144px;
                    height: 144px;
                  }
                `}
              >
                <span
                  css={css`
                    font-size: 12px;
                    line-height: 1.5;
                    letter-spacing: 0.02em;
                    ${mq.large} {
                      font-size: 16px;
                    }
                  `}
                >
                  テーマ別
                  <br />
                  オフ会
                </span>
              </Circle>
              <Circle
                css={css`
                  right: calc(50% + 75px);
                  top: calc(min(88vh, 414px) / 2 + 66px);
                  width: 73px;
                  height: 73px;
                  background-color: #f3f32c;
                  transform: scale(0) rotate(180deg);
                  opacity: 0;
                  transition:
                    opacity 0.4s ease-in 1.7s,
                    transform 0.4s ease-in 1.7s;
                  .show & {
                    transform: scale(1) rotate(360deg);
                    opacity: 1;
                  }
                  ${mq.large} {
                    right: calc(50% + 167px);
                    top: calc(min(88vh, 808px) / 2 + 154px);
                    width: 160px;
                    height: 160px;
                  }
                `}
              >
                <span
                  css={css`
                    font-size: 12px;
                    line-height: 1.5;
                    letter-spacing: 0.02em;
                    ${mq.large} {
                      font-size: 18px;
                    }
                  `}
                >
                  スタート
                  <br
                    css={css`
                      display: block;
                      ${mq.large} {
                        display: none;
                      }
                    `}
                  />
                  アップ
                  <br />
                  ピッチ
                </span>
              </Circle>
            </ul>
          </header>
          <div css={css``}></div>
          <section
            css={css`
              max-width: 1200px;
              margin-block-start: 70px;
              margin-inline: auto;
              padding-inline: 24px;
              ${mq.large} {
                margin-block-start: 80px;
                padding-inline: 40px;
              }
            `}
          >
            <header>
              <SectionTitle en="About" ja="INITIAL Circleについて" />
            </header>
            <div
              css={css`
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                grid-row-gap: 40px;
                margin-block-start: 24px;
                ${mq.large} {
                  flex-direction: row;
                  grid-column-gap: 64px;
                  margin-block-start: 40px;
                }
              `}
            >
              <div
                css={css`
                  display: flex;
                  flex-direction: column;
                  grid-row-gap: 0;
                  ${mq.large} {
                    grid-row-gap: 2em;
                  }
                `}
              >
                <p
                  css={css`
                    margin: 0;
                    color: ${colors.textStrong};
                    font-size: 16px;
                    line-height: 2;
                    letter-spacing: 0.02em;
                    ${mq.large} {
                      font-size: 18px;
                    }
                  `}
                >
                  「INITIAL
                  Circle」は、INITIALユーザーの知見と人脈をつなぎ、循環させるためのユーザーコミュニティです。
                  <br />
                  INITIALを利用する、VC、CVC、事業会社、行政、金融、研究機関、スタートアップのみなさんが、所属する組織や地域、立場の垣根を超えて、自由に交流する場です。
                  <br />
                  INITIAL
                  Circleが、スタートアップと新たな一歩を作り出す場になることを目指します。
                </p>
              </div>
              <img
                src="/static/images/enterprise/circle/section1-img.jpg"
                alt=""
                css={css`
                  display: block;
                  height: auto;
                  border-radius: 12px;
                  ${mq.large} {
                    width: min(600px, 54%);
                    margin-inline: 0;
                  }
                `}
              />
            </div>
          </section>
          <section
            css={css`
              margin-block-start: 40px;
              padding-block: 50px 64px;
              background:
                url(/static/images/enterprise/circle/circle-top.png) 0 376px
                  no-repeat,
                linear-gradient(
                  to bottom,
                  transparent 0,
                  transparent 376px,
                  ${colorYellow} 376px
                );
              background-size: contain;
              ${mq.large} {
                padding-block: 74px 244px;
                background:
                  url(/static/images/enterprise/circle/circle-top.png) 0 400px
                    no-repeat,
                  linear-gradient(
                    to bottom,
                    transparent 0,
                    transparent 400px,
                    ${colorYellow} 400px
                  );
                background-size: contain;
              }
            `}
          >
            <header
              css={css`
                max-width: 1200px;
                margin-inline: auto;
                padding-inline: 24px;
                ${mq.large} {
                  padding-inline: 40px;
                }
              `}
            >
              <SectionTitle en="Voices" ja="参加者の声" />
            </header>
            <div
              css={css`
                width: 100%;
                overflow: hidden;
                ${mq.large} {
                  margin-block-start: -40px;
                  padding-block-start: 40px;
                }
              `}
            >
              <div
                css={css`
                  max-width: 1200px;
                  margin-inline: auto;
                  padding-inline: 24px;
                  ${mq.large} {
                    padding-inline: 40px;
                  }
                  .slick-list {
                    overflow: visible;
                  }
                  .slick-arrow {
                    width: 40px;
                    height: 40px;
                    top: auto;
                    bottom: calc(100% + 20px);
                    left: auto;
                    right: 0;
                    border: 1px solid ${colors.borderStrong};
                    border-radius: 100%;
                    background: ${colors.white00};
                    ::before {
                      content: '';
                      display: block;
                      width: 24px;
                      height: 24px;
                      margin-inline: auto;
                    }
                    &.slick-disabled {
                      border-color: ${colors.gray70};
                    }
                  }
                  .slick-next {
                    ::before {
                      background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzE2MTYxNiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNOC40OTIgNC41MDhhLjcxOC43MTggMCAwIDEgMS4wMTYgMGw3LjQ3IDcuNDdjLjI4LjI4LjI4LjczNSAwIDEuMDE1bC03LjQ3IDcuNDdhLjcxOC43MTggMCAxIDEtMS4wMTYtMS4wMTVsNi45NjMtNi45NjMtNi45NjMtNi45NjJhLjcxOC43MTggMCAwIDEgMC0xLjAxNVoiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==');
                    }
                    &.slick-disabled {
                      ::before {
                        background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iI0FBQUFBQSIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNOC40OTIgNC41MDhhLjcxOC43MTggMCAwIDEgMS4wMTYgMGw3LjQ3IDcuNDdjLjI4LjI4LjI4LjczNSAwIDEuMDE1bC03LjQ3IDcuNDdhLjcxOC43MTggMCAxIDEtMS4wMTYtMS4wMTVsNi45NjMtNi45NjMtNi45NjMtNi45NjJhLjcxOC43MTggMCAwIDEgMC0xLjAxNVoiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==');
                      }
                    }
                  }
                  .slick-prev {
                    right: 47px;
                    ::before {
                      background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSI+PGcgY2xpcC1wYXRoPSJ1cmwoI2EpIj48cGF0aCBmaWxsPSIjMTYxNjE2IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNi41MDggMjAuNDkyYS43MTguNzE4IDAgMCAxLTEuMDE2IDBsLTcuNDctNy40N2EuNzE4LjcxOCAwIDAgMSAwLTEuMDE1bDcuNDctNy40N2EuNzE4LjcxOCAwIDAgMSAxLjAxNiAxLjAxNWwtNi45NjMgNi45NjMgNi45NjMgNi45NjJjLjI4LjI4LjI4LjczNSAwIDEuMDE1WiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9nPjxkZWZzPjxjbGlwUGF0aCBpZD0iYSI+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTAgMGgyNHYyNEgweiIvPjwvY2xpcFBhdGg+PC9kZWZzPjwvc3ZnPg==');
                    }
                    &.slick-disabled {
                      ::before {
                        background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSI+PGcgY2xpcC1wYXRoPSJ1cmwoI2EpIj48cGF0aCBmaWxsPSIjQUFBIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNi41MDggMjAuNDkyYS43MTguNzE4IDAgMCAxLTEuMDE2IDBsLTcuNDctNy40N2EuNzE4LjcxOCAwIDAgMSAwLTEuMDE1bDcuNDctNy40N2EuNzE4LjcxOCAwIDAgMSAxLjAxNiAxLjAxNWwtNi45NjMgNi45NjMgNi45NjMgNi45NjJjLjI4LjI4LjI4LjczNSAwIDEuMDE1WiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9nPjxkZWZzPjxjbGlwUGF0aCBpZD0iYSI+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTAgMGgyNHYyNEgweiIvPjwvY2xpcFBhdGg+PC9kZWZzPjwvc3ZnPg==');
                      }
                    }
                  }
                `}
              >
                <ul
                  css={css`
                    margin: 0;
                    padding: 0;
                    padding-block: 24px;
                    ${mq.large} {
                      padding-block: 40px 0;
                    }
                  `}
                >
                  <Slider {...sliderSettings}>
                    <Section2Voice
                      users={[
                        {
                          name: '岡安 良将',
                          imgSrc:
                            '/static/images/enterprise/circle/avatar-6.png',
                        },
                      ]}
                      company="株式会社ロッテベンチャーズ・ジャパン"
                      voice="INITIALユーザーと情報交換し、案件のご紹介がしあえる良い機会となっています。交流会で出会った事業会社の方を投資先にご紹介し、新規案件が生まれ、ビジネス創出のいい機会になったこともありました。フランクに交流できるため、純粋に毎月楽しみにしています。"
                    />
                    <Section2Voice
                      users={[
                        {
                          name: '大長 敬典',
                          imgSrc:
                            '/static/images/enterprise/circle/avatar-8.png',
                        },
                      ]}
                      company="THE CREATIVE FUND"
                      voice="投資家、CVC、新規事業担当者が集まる場がここにあります。自分だけでなく、「多くの人が悩んでいることに気付くことができる場所」であるのが特徴だと思います。ご縁がある場所なので、それらの悩みが解決される出会いがあるかもしれません。より多くの人が参加してほしいです。"
                    />
                    <Section2Voice
                      users={[
                        {
                          name: '大窪信一',
                          imgSrc:
                            '/static/images/enterprise/circle/avatar-2.png',
                        },
                      ]}
                      company="サントリーホールディングス株式会社 未来事業開発部"
                      voice="新しい出会いはもちろんのこと、協業中のスタートアップの方のお話を改めてお聞きし、より連携が深くなったり、 事業会社・VCの方と久しぶりにお会いして近況を報告しあうなど、次のイノベーションのきっかけとなるイベントです。"
                    />
                    <Section2Voice
                      users={[
                        {
                          name: '吉崎 裕哉',
                          imgSrc:
                            '/static/images/enterprise/circle/avatar-4.png',
                        },
                      ]}
                      company="東京海上ホールディングス株式会社 デジタル戦略部"
                      voice="INITIAL Circleはスタートアップ、投資家、新規事業担当者がご参加されるリアルイベントで、スタートアップとの接点を目的に参加しています。また事業会社のCVC担当者も多くご参加されており、各社の投資戦略や活動を伺うことで多くの学びを得ています。"
                    />
                    <Section2Voice
                      users={[
                        {
                          name: '西中 裕一朗',
                          imgSrc:
                            '/static/images/enterprise/circle/avatar-5.png',
                        },
                      ]}
                      company="株式会社リコー 経営企画部"
                      voice="スタートアップ、事業会社と共創のためのきっかけ作りができます。 スタートアップピッチを直接聞き、深い議論をすることや、普段関わりの少ない事業会社、スタートアップのCVに関わる方々と意見交換をすることができます。"
                    />
                  </Slider>
                </ul>
              </div>
            </div>
            <div
              css={css`
                display: flex;
                flex-direction: column;
                grid-row-gap: 64px;
                max-width: 1200px;
                margin-block-start: 56px;
                margin-inline: auto;
                padding-inline: 24px;
                ${mq.large} {
                  grid-row-gap: 160px;
                  padding-inline: 40px;
                  margin-block-start: 120px;
                }
              `}
            >
              <Section2SubSection
                imgPosition="right"
                imgSrc="/static/images/enterprise/circle/section2-img-1.jpg"
                imgAlt=""
              >
                <div
                  css={css`
                    display: flex;
                    flex-direction: column;
                    grid-row-gap: 16px;
                    ${mq.large} {
                      grid-row-gap: 32px;
                    }
                  `}
                >
                  <Section2SubSectionTitle
                    en="Pitch & Meetup"
                    ja="ピッチ＆交流会"
                    tags={['毎月', 'オフライン']}
                  />
                  <Section2Line>
                    東京丸の内にあるユーザベース本社を拠点に、スタートアップピッチと、ユーザー同士の交流を目的としたミートアップを開催。毎月100名以上のユーザーにご参加いただいています。
                  </Section2Line>
                </div>
              </Section2SubSection>
              <Section2SubSection
                imgPosition="left"
                imgSrc="/static/images/enterprise/circle/section2-img-2.jpg"
                imgAlt=""
              >
                <div
                  css={css`
                    display: flex;
                    flex-direction: column;
                    grid-row-gap: 16px;
                    ${mq.large} {
                      grid-row-gap: 32px;
                    }
                  `}
                >
                  <Section2SubSectionTitle
                    en="Seminar"
                    ja="勉強会"
                    tags={['毎月', 'オフライン']}
                  />
                  <Section2Line>
                    スタートアップ投資や協業に関する勉強会を開催。これまで「実践者と語るCVC立ち上げのリアル」「スタートアップM&A勉強会」「投資判断のリアル」をテーマに、丸の内のユーザベースオフィスで開催。
                  </Section2Line>
                </div>
              </Section2SubSection>
            </div>
          </section>
          <div
            css={css`
              background:
                url(/static/images/enterprise/circle/circle-bottom.png) 0 64px
                  no-repeat,
                linear-gradient(
                  to bottom,
                  ${colorYellow} 64px,
                  transparent 64px
                ),
                transparent 0;
              background-size: contain;
              ${mq.large} {
                background:
                  url(/static/images/enterprise/circle/circle-bottom.png) 0 79px
                    no-repeat,
                  linear-gradient(
                    to bottom,
                    ${colorYellow} 79px,
                    transparent 79px
                  ),
                  transparent 0;
                background-size: contain;
              }
            `}
          >
            <section
              css={css`
                max-width: 1200px;
                margin-inline: auto;
                padding-block-end: 52px;
                padding-inline: 24px;
                ${mq.large} {
                  padding-block-end: 64px;
                  padding-inline: 40px;
                }
              `}
            >
              <header>
                <SectionTitle en="FAQ" ja="よくある質問と回答" />
              </header>
              <div
                css={css`
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                  grid-row-gap: 40px;
                  margin-block-start: 24px;
                  ${mq.large} {
                    flex-direction: row;
                    align-items: flex-start;
                    grid-column-gap: 64px;
                    margin-block-start: 40px;
                  }
                `}
              >
                <div
                  css={css`
                    flex-grow: 1;
                    display: flex;
                    flex-direction: column;
                    grid-row-gap: 8px;
                    ${mq.large} {
                      grid-row-gap: 16px;
                    }
                  `}
                >
                  <FAQ question="INITIAL Circleへの参加は有料ですか？">
                    INITIALの有料プランご契約いただいていれば、追加料金なしでご参加いただけます。
                  </FAQ>
                  <FAQ question="INITIALの有料プランを契約していませんが、INITIAL Circleに参加できますか？">
                    INITIAL
                    Circleは、INITIALの有料プランをご契約いただいているユーザー同士の交流の場となります。ご参加には有料プランのご契約が必要です。
                  </FAQ>
                  <FAQ question="どんな人たちが参加していますか？">
                    事業会社、CVC、VC、金融機関に所属の方々。事業会社からは、経営企画や新規事業開発、オープンイノベーション関連の部署に所属の方々からご参加いただいています。
                  </FAQ>
                  <FAQ question="イベントの開催頻度と開催場所を教えてください。">
                    ピッチ＆交流会と勉強会は、ユーザベースの丸の内オフィス（東京）で毎月開催しています。開催日時が決まったイベントから、
                    <a
                      href="https://help.initial.inc/ja/articles/11374241"
                      target="_blank"
                      css={css`
                        color: ${colors.link};
                        text-decoration: underline solid transparent;
                        :hover {
                          text-decoration: underline solid Currentcolor;
                          transition: text-decoration 0.2s ease 0s;
                        }
                      `}
                    >
                      イベントページ上
                    </a>
                    でお知らせします。
                  </FAQ>
                  <FAQ question="ピッチイベントや勉強会のオンライン配信はありますか？">
                    オフラインのみの開催となります。多くの方にご都合いただけるよう、日程が決まり次第、
                    <a
                      href="https://help.initial.inc/ja/articles/11374241"
                      target="_blank"
                      css={css`
                        color: ${colors.link};
                        text-decoration: underline solid transparent;
                        :hover {
                          text-decoration: underline solid Currentcolor;
                          transition: text-decoration 0.2s ease 0s;
                        }
                      `}
                    >
                      イベントページ上
                    </a>
                    でご案内いたします。
                  </FAQ>
                </div>
                <img
                  src="/static/images/enterprise/circle/section3-img.png"
                  alt=""
                  css={css`
                    display: block;
                    width: 256px;
                    height: auto;
                    margin-inline: auto;
                    ${mq.large} {
                      width: min(324px, 30%);
                      margin-inline: 0;
                    }
                  `}
                />
              </div>
            </section>
          </div>
        </div>
      </EnterpriseTemplate>
    </>
  )
}

type CircleProps = {
  className?: string
  children: React.ReactNode
}

const Circle: React.FC<CircleProps> = (props) => {
  return (
    <li
      className={props.className}
      css={css`
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 100%;
        color: ${colors.textStrong};
        font-weight: ${font.weight.bold};
        text-align: center;
      `}
    >
      {props.children}
    </li>
  )
}

const SectionTitle: React.FC<{ en: string; ja: string }> = (props) => {
  return (
    <>
      <p
        css={css`
          margin: 0;
          color: ${colors.textStrong};
          font-size: 42px;
          font-weight: ${font.weight.bold};
          line-height: 1.25;
          letter-spacing: 0.01em;
          ${mq.large} {
            font-size: 72px;
          }
        `}
      >
        {props.en}
      </p>
      <h2
        css={css`
          margin: 0;
          color: ${colorOrange};
          font-size: 16px;
          font-weight: ${font.weight.bold};
          line-height: 1.5;
          letter-spacing: 0.02em;
          ${mq.large} {
            font-size: 18px;
          }
        `}
      >
        {props.ja}
      </h2>
    </>
  )
}

type Section2LineProps = {
  children: React.ReactNode
}

const Section2Line: React.FC<Section2LineProps> = (props) => {
  return (
    <p
      css={css`
        margin: 0;
        font-size: 15px;
        line-height: 1.75;
        letter-spacing: 0.02em;
        ${mq.large} {
          font-size: 18px;
          line-height: 2;
        }
      `}
      {...props}
    />
  )
}

const Section2Voice: React.FC<{
  users: User[]
  company: string
  voice: string
}> = (props) => {
  return (
    <li
      css={css`
        width: 264px;
        ${mq.large} {
          width: auto;
        }
      `}
    >
      <div
        css={css`
          display: flex;
          flex-direction: column;
          grid-row-gap: 16px;
          margin-inline-end: 8px;
          padding-block: 32px;
          padding-inline: 24px;
          background: ${colors.white00};
          border-radius: 12px;
          ${mq.large} {
            grid-row-gap: 24px;
            margin-inline-end: 16px;
            padding-block: 40px;
            padding-inline: 40px;
          }
        `}
      >
        <div
          css={css`
            display: flex;
          `}
        >
          {props.users.map((user, index) => (
            <img
              src={user.imgSrc}
              alt=""
              css={css`
                display: block;
                width: 64px;
                height: auto;
                border: 1px solid ${colors.black10};
                border-radius: 100%;
                :not(:first-child) {
                  margin-inline-start: -8px;
                }
                ${mq.large} {
                  width: 72px;
                }
              `}
              key={index}
            />
          ))}
        </div>
        <p
          css={css`
            margin: 0;
            font-size: 15px;
            line-height: 1.75;
            letter-spacing: 0.02em;
            ${mq.large} {
              font-size: 16px;
            }
          `}
        >
          {props.voice}
        </p>
        <p
          css={css`
            margin: 0;
            font-size: 15px;
            font-weight: ${font.weight.bold};
            line-height: 1.5;
            letter-spacing: 0.02em;
            ${mq.large} {
              font-size: 16px;
            }
          `}
        >
          {props.company}
          <br />
          {props.users.map(
            (user, index) => (0 < index ? '、' : '') + user.name + ' 氏'
          )}
        </p>
      </div>
    </li>
  )
}

type Section2SubSectionProps = {
  imgPosition: 'left' | 'right'
  imgSrc: string
  imgAlt: string
  children: React.ReactNode
}

const Section2SubSection: React.FC<Section2SubSectionProps> = (props) => {
  return (
    <section
      css={css`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        grid-row-gap: 16px;
        ${mq.large} {
          flex-direction: ${props.imgPosition == 'left'
            ? 'row-reverse'
            : 'row'};
          grid-column-gap: 64px;
        }
      `}
    >
      <div css={css``}>{props.children}</div>
      <img
        src={props.imgSrc}
        alt={props.imgAlt}
        css={css`
          display: block;
          border-radius: 12px;
          ${mq.large} {
            width: min(600px, 54%);
          }
        `}
      />
    </section>
  )
}

const Section2SubSectionTitle: React.FC<{
  en: string
  ja: string
  tags: string[]
}> = (props) => {
  return (
    <header>
      <ul
        css={css`
          margin: 0;
          padding: 0;
          display: flex;
          grid-column-gap: 4px;
        `}
      >
        {props.tags.map((tag, index) => (
          <li
            css={css`
              padding: 3px 8px;
              background: ${colors.black10};
              border-radius: 15px;
              color: ${colors.textInvert};
              font-size: 11px;
              line-height: 1.25;
              letter-spacing: 0.02em;
            `}
            key={index}
          >
            {tag}
          </li>
        ))}
      </ul>
      <p
        css={css`
          margin: 0;
          color: ${colors.textStrong};
          font-size: 36px;
          font-weight: ${font.weight.bold};
          line-height: 1.25;
          letter-spacing: 0.01em;
          ${mq.large} {
            font-size: 48px;
            line-height: 1.5;
          }
        `}
      >
        {props.en}
      </p>
      <h3
        css={css`
          margin: 0;
          color: ${colorOrange};
          font-size: 16px;
          line-height: 1.5;
          letter-spacing: 0.02em;
          ${mq.large} {
            font-size: 18px;
          }
        `}
      >
        {props.ja}
      </h3>
    </header>
  )
}

type FAQProps = {
  question: string
  children: React.ReactNode
}

const FAQ: React.FC<FAQProps> = (props) => {
  const [open, setOpen] = React.useState(false)

  const onClickHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
    ;(e.target as HTMLElement).blur()
    setOpen(!open)
  }

  return (
    <dl
      css={css`
        margin: 0;
        display: flex;
        flex-direction: column;
        background: ${colors.white00};
        border-radius: 12px;
        transition: box-shadow 0.2s ease-in;
        :hover,
        :focus {
          box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.12);
        }
      `}
    >
      <dt>
        <button
          onClick={onClickHandler}
          css={css`
            display: flex;
            justify-content: space-between;
            align-items: center;
            grid-column-gap: 16px;
            width: 100%;
            padding-block: 16px;
            padding-inline: 24px;
            background: none;
            border: none;
            border-radius: ${open ? '12px 12px 0 0' : '12px'};
            font-size: 16px;
            font-weight: ${font.weight.bold};
            line-height: 1.5;
            letter-spacing: 0.02em;
            text-align: left;
            cursor: pointer;
            ${mq.large} {
              padding-block: 24px;
              padding-inline: 40px;
            }
          `}
        >
          <span>{props.question}</span>
          <IcomoonIcon
            name="arrow1-down"
            css={css`
              transform: rotate(${open ? '180deg' : '360deg'});
              transition: transform 0.2s ease-in;
            `}
          />
        </button>
      </dt>
      <dd
        css={css`
          margin: 0;
          max-height: ${open ? '1200px' : '0'};
          flex-grow: 0;
          margin-block-end: ${open ? '16px' : '0'};
          padding-inline: 24px;
          font-size: 16px;
          line-height: 1.5;
          letter-spacing: 0.02em;
          overflow: hidden;
          transition:
            max-height 0.2s ease-in,
            margin-block 0.2s ease-in;
          ${mq.large} {
            margin-block-end: ${open ? '24px' : '0'};
            padding-inline: 40px;
          }
        `}
      >
        {props.children}
      </dd>
    </dl>
  )
}

export default CirclePage
